// Add an action to call a supplied function when a click occurs on the page that is outside of `node`
export default function clickOutside(node, fn) {

    const handleClick = event => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            fn();
        }
    }

    document.addEventListener('click', handleClick, true);

    return {
        destroy() {
            document.removeEventListener('click', handleClick, true);
        }
    }
}